import axios from 'axios';
import store from '../redux/store';
import { showSuccessAlert } from '../redux/actions/modals';

const instance = axios.create()

instance.interceptors.request.use ((config) => {
	const logIn = JSON.parse(sessionStorage.getItem('login'));
	
	config = {...config, baseURL: sessionStorage.getItem('base_url')};

	if (logIn && logIn.sessionkey) {
		config = {...config, ...{ headers: {common: {'SessionKey': `${logIn.sessionkey}`} } } }
	} 

	return config;
});

instance.interceptors.response.use(
	function (response) {
    	return response;
  	}, function (error) {
		const logIn = JSON.parse(sessionStorage.getItem('login'));
		
		if (logIn) {
			if (error.response) {
				if ([401].includes(error.response.status)) {
					sessionStorage.removeItem('login');
					window.location = '/?expired=1'
				} else {
					if (error.response.data) {
						const message = typeof error.response.data === "string" ? error.response.data : "There was an error completing your request";
						store.dispatch(showSuccessAlert(message, "Error"));
					} else {
						store.dispatch(showSuccessAlert("There was an error completing your request!", "Error"));
					}
				}
			} else {
				store.dispatch(showSuccessAlert("There was an error completing your request!", "Error"));
			}
		}

		return Promise.reject(error);
	}
);

export default instance;